import { combineReducers, Reducer } from 'redux';
import estimations from '../estimations/reducer/reducer';
import products from '../products/reducer';
import order from '../order/reducer/index';
import admin from '../admin/reducer/reducer';
import user from '../user/reducer';
import { connectRouter } from 'connected-react-router';
import { History } from 'history';
import userOrders from '../order/reducer';
import userEstimations from '../estimations/reducer';
import estimationDetails from '../estimation-details/reducer';
import notifications from './notifications';
import reducer from './reducer';

export default (history: History): Reducer =>
    combineReducers({
        application: reducer,
        notifications,
        estimations,
        products,
        order,
        user,
        admin,
        router: connectRouter(history),
        userOrders,
        userEstimations,
        estimationDetails
    });



// WEBPACK FOOTER //
// ./src/application/core/rootReducer.ts